<template>
  <div>
    <div
      v-for="location in closedLocations"
      :key="location.id"
      class="text-white text-center bg-primary banner-container"
      :class="{
        'q-mb-lg': $q.screen.width >= 1440,
        'q-mb-md': $q.screen.width >= 600,
        'q-mb-sm': $q.screen.width < 600,
      }"
    >
      <div class="q-py-sm text-weight-medium">
        {{ location.closedReason }}
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'LocationClosedBanner',

  data() {
    return {
    };
  },
  computed: {
    ...mapState('location', { allLocations: 'all' }),

    closedLocations() {
      return this.allLocations.filter(
        (l) => (l.closed || !l.deliveryMethods || !l.deliveryMethods.length > 0) && l.closedReason,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-container {
  margin-left: -24px;
  margin-right: -24px;
  @media (max-width: 1439px) {
    margin-left: -16px;
    margin-right: -16px;
  }
  @media (max-width: 599px) {
    margin-left: -8px;
    margin-right: -8px;
  }
}
</style>
